import Person from "./scripts/Person"
import MainScreen from "./scripts/MainScreen"
import AboutScreen from "./scripts/AboutScreen"
import ProgramsScreen from "./scripts/ProgramsScreen"
import ProgramsOneScreen from "./scripts/ProgramsOneScreen"
import TermsScreen from "./scripts/TermsScreen"
import PrivacyScreen from "./scripts/PrivacyScreen"
import ContactScreen from "./scripts/ContactScreen"
import React from "react"
import ReactDOM from "react-dom/client"

import {BrowserRouter as Router, Routes, Route, Link} from "react-router-dom";


const person1 = new Person("Brad")
if (document.querySelector("#render-react-example-here")) {
    const root = ReactDOM.createRoot(document.querySelector("#render-react-example-here"))
    root.render(
        <Router>
            <Routes>
                <Route path="/" element={<MainScreen/>}/>
                <Route path="/about" element={<AboutScreen/>}/>
                <Route path="/services" element={<ProgramsScreen/>}/>
                <Route path="/terms-of-service" element={<TermsScreen/>}/>
                <Route path="/privacy-policy" element={<PrivacyScreen/>}/>
                <Route path="/contact-us" element={<ContactScreen/>}/>
                <Route path="/services/:id" element={<ProgramsOneScreen/>}/>
            </Routes>
        </Router>
    )
}
